/**
 * Code hiện tại kiểm tra `subscription?._state !== 'closed'` - đây là field nội bộ của
 * zen-observable (Amplify v2). Amplify v6 dùng rxjs và không có field này. Wrapper tự
 * quản state để 3 call site kiểm tra `_state` chạy đúng ở cả hai phiên bản.
 *
 * `mapNext` cho phép P5 tái tạo lớp `.value` mà v6 đã bỏ khỏi payload subscription.
 */
export const createSubscriptionHandle = (observable, mapNext) => ({
    subscribe(observer) {
        let state = 'ready';

        const inner = observable.subscribe({
            next: payload => {
                if (!observer?.next) {
                    return;
                }
                observer.next(mapNext ? mapNext(payload) : payload);
            },
            error: err => {
                state = 'closed';
                observer?.error?.(err);
            },
            complete: () => {
                state = 'closed';
                observer?.complete?.();
            }
        });

        return {
            get _state() {
                return state;
            },
            get closed() {
                return state === 'closed';
            },
            unsubscribe() {
                state = 'closed';
                inner.unsubscribe();
            }
        };
    }
});

export const isSubscriptionDocument = query => {
    if (typeof query !== 'string') {
        return false;
    }
    return /^\s*subscription\b/.test(query);
};

export default { createSubscriptionHandle, isSubscriptionDocument };
